import { observer } from "mobx-react";
import React from "react";
import { useMatchedApp } from "Shared/Hooks";
import { RenderingStatus } from "Enumerations";
import { useRootStore } from "Store/RootStore";
import { TorusRequiredPage } from "Components/Pages/TorusRequiredPage";
import { LoginErrorPage } from "Components/Pages/LoginErrorPage";
import { LoadingPage } from "Components/Pages/LoadingPage";

const AuthStatusPageBase = (props: { children: React.ReactElement }) => {
    const matchedApp = useMatchedApp();
    const { loginStatus, IsTorusRequirementMet } = useRootStore("AuthStore");

    switch (loginStatus) {
        case RenderingStatus.Ready:
            return matchedApp?.torusRequired && IsTorusRequirementMet === false ? <TorusRequiredPage /> : props.children;
        case RenderingStatus.Error:
            return <LoginErrorPage />;
        default:
            return <LoadingPage label="Please wait while we are signing you in" />;
    }
};

export const AuthStatusPage = observer(AuthStatusPageBase);
